import React from 'react';
import CircularProgressChart from './charts/CircularProgressChart';

export default function StatCard({ icon, value, label, color, percent, chartColor }) {
  return (
    <div className="stat-card">
      {percent != null ? (
        <CircularProgressChart percent={percent} color={chartColor} />
      ) : (
        <div className={`icon-box ${color}`}><i className={icon} /></div>
      )}
      <div className="stat-info">
        <h3>{value}</h3>
        <p>{label}</p>
      </div>
    </div>
  );
}
